/* Author M. Atoar Rahman
 * Title: Partner Stock Distribution Approval
 * Description: Page for Partner Stock Distribution Approval
 * Date: 27/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { PartnerStockDistributionApprovalProvider } from '../partner/stockDistributionApproval/ContextAPI';
import Index from '../partner/stockDistributionApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerStockDistributionApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-stock-distribution-approval']) return <PermissionDenied />;

    return (
        <PartnerStockDistributionApprovalProvider>
            <Index />
        </PartnerStockDistributionApprovalProvider>
    );
}
